import { all } from 'redux-saga/effects';
import watchUpdate from './update';
import watchGet from './get';
import watchUpdateAgentCapc from './updateAgentCapc';

export function* watchSLA() {
  yield all([watchGet(), watchUpdate(), watchUpdateAgentCapc()]);
}
